import React from "react";

import { isArray } from "~/tools/is-array";

import { Context } from "./_context";
import { type TemplateVariableDefinition, TemplateVariableDefinitions } from "./definitions";

export interface TemplateVariablesBoundaryProps {
	variables: TemplateVariableDefinitions | ReadonlyArray<TemplateVariableDefinition>;
	children: React.ReactNode;
}

export const TemplateVariablesBoundary: React.FC<TemplateVariablesBoundaryProps> = ({ variables, children }) => {
	const context = React.useMemo(
		() => (isArray(variables) ? new TemplateVariableDefinitions(variables) : variables),
		[variables],
	);

	return <Context.Provider value={context}>{children}</Context.Provider>;
};
